<template>
  <div class="w-100">
    <template v-if="result_push == 'success'">
      <div class="rounded-100 my-2 w-20 mx-auto mb-4">
        <div class="bg-green rounded-100 mx-auto size-icon-in">
          <img src="../../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
        </div>
      </div>
      <div class="w-100 text-center">
        <p class="mb-0 body-2-2 text-18 text-green font-extrabold">Successfully uploaded proof of payment</p>
        <p class="mb-5 body-2-2">Please wait because the data is being checked. You can check the results via the "Check Payment Status" button</p>
      </div>
      <button class="g-btn g-btn-primary g-btn-lg mb-3 w-100" @click="close()">Close</button>
    </template>
    <template v-else>
      <span id="payment_pending_header"></span>
      <div class="w-100 mb-3" id="bank_name">
        <p class="mb-1 body-3-1">Bank/E-Wallet Name<span class="text-danger">*</span></p>
        <input 
          type="text" 
          class="form-control body-2-1" 
          v-model="form.bank_name"
          :class="{'border-danger' : validate_form.bank_name != ''}">
        <p class="mb-0 body-3 text-danger mt-1" v-if="validate_form.bank_name != ''">
          {{validate_form.bank_name}}
        </p>
      </div>
      <div class="w-100 mb-3">
        <p class="mb-1 body-3-1">Account Holder<span class="text-danger">*</span></p>
        <input type="text" class="form-control body-2-1" v-model="form.account_name"
          :class="{'border-danger' : validate_form.account_name != ''}">
        <p class="mb-0 body-3 text-danger mt-1" v-if="validate_form.account_name != ''">
          {{validate_form.account_name}}
        </p>
      </div>
      <div class="w-100 mb-3">
        <p class="mb-1 body-3-1">Account Number<span class="text-danger">*</span></p>
        <input type="text" class="form-control body-2-1" v-model="form.account_number" :class="{'border-danger' : validate_form.account_number != ''}">
        <p class="mb-0 body-3 text-danger mt-1" v-if="validate_form.account_number != ''">
          {{validate_form.account_number}}
        </p>
      </div>
      <div class="w-100 mb-3">
        <p class="mb-2 body-3-1">Transfer Date<span class="text-danger">*</span></p>
        <p v-if="validate_form.tf_date != ''" class="mb-0 body-3 text-danger mt-1">
          {{validate_form.tf_date}}
        </p>
        <div class="row slim-grid-row">
          <div class="col-4">
            <p class="mb-1 body-3-3">Year<span class="text-danger">*</span></p>
            <input type="text" class="form-control body-2-1" v-model="form.payment_date.year" :class="{'border-danger' : validate_form.year != ''}">
            <p class="mb-0 body-3 text-danger mt-1" v-if="validate_form.year != ''">
              {{validate_form.year}}
            </p>
          </div>
          <div class="col-4">
            <p class="mb-1 body-3-3">Month<span class="text-danger">*</span></p>
            <input type="text" class="form-control body-2-1" v-model="form.payment_date.month" :class="{'border-danger' : validate_form.month != ''}">
            <p class="mb-0 body-3 text-danger mt-1" v-if="validate_form.month != ''">
              {{validate_form.month}}
            </p>
          </div>
          <div class="col-4">
            <p class="mb-1 body-3-3">Day<span class="text-danger">*</span></p>
            <input type="text" class="form-control body-2-1" v-model="form.payment_date.day" :class="{'border-danger' : validate_form.day != ''}">
            <p class="mb-0 body-3 text-danger mt-1" v-if="validate_form.day != ''">
              {{validate_form.day}}
            </p>
          </div>
        </div>
      </div>
      <div class="w-100 mb-4">
        <p class="mb-1 body-3-1">Transfer Receipt<span class="text-danger">*</span></p>
        <div class="text-center mb-0" :key="form.image.key" :class="{'border-danger':validate_form.image != ''}">
          <label v-if="form.image.original == null" class="w-100 cursor-pointer" for="file_image">
            <div class="w-100 bg-light-page py-4 border-2-dashed rounded-6 cursor-pointer" style="box-shadow: 4px 3px 4px 0px #ccccccba;">
              <img src="../../../assets/img/icon/ar-camera-light.png" width="40">
              <p class="mb-0 pt-1 body-1 text-14 font-bold text-center">{{$t('hotel.action.choose-photo')}}</p>
              <input type="file" ref="file_upload" accept="image/png, image/jpeg, image/jpg" id="file_image" class="d-none" @change="pushImage" />
            </div>
          </label>
          <div class="w-100 bg-light-page border rounded-6 position-relative" v-else style="box-shadow: 4px 3px 4px 0px #ccccccba;">
            <div class="rounded-3 bg-back cursor-pointer position-absolute m-2" @click="resetImage" style="z-index: 1049;right: 0">
              <img src="../../../assets/img/icon/cancel.png" class="p-2" width="30">
            </div>
            <img :src="form.image.preview" class="rounded-6 w-100 object-fit" style="height: 190px">
          </div>
        </div>
        <p class="mb-0 body-3 text-danger mt-1" v-if="validate_form.image != ''">
          {{validate_form.image}}
        </p>
      </div>
      <div class="w-100 mb-3" v-if="!(result_push == '' || result_push == 'success')">
        <ErrorMessage :message="result_push"></ErrorMessage>
      </div>
      <div class="row">
        <div class="col-4">
          <button class="g-btn g-btn-light g-btn-lg mb-3 w-100" @click="close()">Cancel</button>
        </div>
        <div class="col-8">
          <state-button :click="SubmitConfirmPayment" size="lg" block>Confirm</state-button>
        </div>
      </div>	
    </template>
  </div> 	
</template>

<script>
  import moment from "moment";
  import {post} from '@/services/index.js'
  import { mapGetters } from "vuex";
  import { validationMixin } from "vuelidate";
	const { numeric } = require("vuelidate/lib/validators");

  export default {
    props: {
      tx_order_id:{
        type: String,
        default: ''
      },
      module:{
        type: String,
        default: 'CONCIERGE_UPSELLING'
      }
    },
    data() {
      return {
        form:{
          bank_name: '',
          account_name: '',
          account_number: '',
          payment_date: {
            year: moment().format("YYYY"),
            month: moment().format("MM"),
            day: moment().format("DD"),
          },
          image:{
            original: null,
            preview: null,
            key: 0
          }
        },
        validate_form:{
          bank_name: '',
          account_name: '',
          account_number: '',
          year: '',
          month: '',
          day: '',
          tf_date: '',
          image: ''
        },
        result_push: ''
      }
    },
    mixins: [validationMixin],
    validations: {
      form:{
        payment_date:{
          year:{
            numeric
          },
          month:{
            numeric
          },
          day:{
            numeric
          }
        }
      }
    },
    computed:{
			...mapGetters(['getMerchant'])
		},
    methods:{
      pushImage(e) {
        e.preventDefault();
        var files = this.$refs.file_upload.files;
        if (!files.length){
          return;
        }
        this.form.image.original = files[0]
        this.form.image.preview = URL.createObjectURL(this.form.image.original);
        this.form.image.key++
      },
      resetImage(){
      	this.form.image.original = null
        this.form.image.preview = null
      },
      combineDate(){
				let date = moment(`${this.form.payment_date.year}-${this.form.payment_date.month}-${this.form.payment_date.day}`,'YYYY-M-D').format()
				return date
			},
      resetValidateForm(){
      	this.validate_form = {
					bank_name: '',
					account_name: '',
					account_number: '',
					year: '',
					month: '',
					day: '',
					tf_date: '',
					image: ''
				}
      },
      validateForm(){
				return new Promise((success,fail)=>{
					this.resetValidateForm()
					let total_error = 0 
					if(this.form.bank_name == ''){
						total_error++
						this.validate_form.bank_name = 'Please input bank/e-wallet name'
					}
					if(this.form.account_name == ''){
						total_error++
						this.validate_form.account_name = 'Please input account holder name'
					}
					if(this.form.account_number == ''){
						total_error++
						this.validate_form.account_number = 'Please input account number'
					}

					let validate_date = {
						year: {
							required: this.form.payment_date.year == '',
							min: this.form.payment_date.year.toString().length != 4,
							non_numeric: this.$v.form.payment_date.year.$invalid
						},
						month: {
							required: this.form.payment_date.month == '',
							min: Number(this.form.payment_date.month) > 12,
							non_numeric: this.$v.form.payment_date.month.$invalid
						},
						date: {
							required: this.form.payment_date.day == '',
							min: Number(this.form.payment_date.day) > 31,
							non_numeric: this.$v.form.payment_date.day.$invalid
						}
					}

					if(validate_date.year.required || validate_date.year.min || validate_date.year.non_numeric){
						total_error++
						this.validate_form.year = validate_date.year.non_numeric ? this.$t('affiliate.validation.please-input-year-in-numbers') : this.$t('affiliate.validation.please-input-valid-year')
					}
					if(validate_date.month.required || validate_date.month.min || validate_date.month.non_numeric){
						total_error++
						this.validate_form.month = validate_date.month.non_numeric ? this.$t('affiliate.validation.please-input-month-in-numbers') : this.$t('affiliate.validation.please-input-valid-month')
					}
					if(validate_date.date.required || validate_date.date.min || validate_date.date.non_numeric){
						total_error++
						this.validate_form.day = this.$t('affiliate.validation.please-input-valid-date')
					}

					let invalid_date = (!validate_date.year.required && !validate_date.year.min && !validate_date.year.non_numeric && !validate_date.month.required && !validate_date.month.min && !validate_date.month.non_numeric && !validate_date.date.required && !validate_date.date.min && !validate_date.date.non_numeric) && this.combineDate() == 'Invalid date'

					if(invalid_date){
						total_error++
						this.validate_form.tf_date = this.$t('affiliate.validation.invalid-date-please-ensure-that-the-date-is-correct-exists')
					}
					if(this.form.image.original == null){
						total_error++
						this.validate_form.image = 'Please upload transfer receipt'
					}

					if(total_error > 0){
						fail()
					}else{
						success()
					}
				})
			},
      SubmitConfirmPayment(){
      	return new Promise((success,fail)=>{
          this.result_push = ''
      		this.validateForm().then(()=>{
      			this.$compressImage(this.form.image.original).then(compressResult=>{
      				let img_data = compressResult != false ? compressResult : null 
      				let fd = new FormData()
			        fd.append("payment_invoice", img_data, img_data.name)
			        fd.append("merchant_id", this.getMerchant.id)
			        fd.append("bank_name", this.form.bank_name)
			        fd.append("account_name", this.form.account_name)
			        fd.append("account_number", this.form.account_number)
			        fd.append("payment_date", moment(this.combineDate()).format("YYYY-MM-DD"))

			        post("CORE_HOTEL",`merchant-pos/transaction/${this.tx_order_id}/payment-confirmation`,fd).then(response=>{
		            let res = response.data
		            if(res.success){
                  this.result_push = 'success'
		            	success(res.message)
		            }else{
                  this.result_push = res.message
			            fail(res.message)
		            }
		          })
		        })
      		}).catch(()=>{
      			this.$smoothScroll("payment_pending_header")
      			fail("Incomplete form")
      		})
      	})
      },
      close(){
        this.$emit('close')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/general/payment/PaymentConfirm.vue